import React from 'react';
import cm from 'classnames';
import styles from './_loader.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const Loader = ({ className, ...rest }: Props) => {
  return <div {...rest} className={cm(styles.Loader, className)} />;
};
